export default __webpack_public_path__ + "static/media/thumbnail.aba87fda.png";